import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ClientFilters, ClientQueryParams } from '../client.data';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'ifb-client-list-filter-dialog',
    templateUrl: './client-list-filter-dialog.component.html',
    standalone: false
})
export class ClientListFilterDialogComponent {
  form: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<ClientListFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder) {

    this.form = this.formBuilder.group({
      name: this.data.query.name || '',
      oidcAudience: this.data.query.oidcAudience || '',
      active: this.data.query.active || ''
    });
  }

  static show(dialog: MatDialog, query: ClientQueryParams): Observable<any> {
    return dialog.open(ClientListFilterDialogComponent, {
      data: { query },
      closeOnNavigation: true,
    }).afterClosed();
  }

  onConfirmed(formValues: unknown): void {
    this.dialogRef.close(new ClientFilters(formValues));
  }
}
